import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
import { CommonService } from "./../../../../services/common.service";

const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
@Injectable({
  providedIn: "root"
})
export class WidgetOverallStatusTrendService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(
    public generic: GenericHttpService,
    private commonService: CommonService
  ) {}

  getSLAtrendData(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: url, // "./assets/data/p-d-otiftrends.json",
      query: params
    };
    return this.generic
      .httpRequest(option)
      .pipe(
        catchError(this.generic.handleError),
        map(this.processSLAtrendData)
      );
  }
  processSLAtrendData(response: any) {
    const total = [];
    const categories = [];
    if (!response.data.length) {
      return { success: false };
    }
    const total_units_delivered = [];
    const units_invoiced = [];
    const units_delivered = [];
    const dataSets = response.data.map(dataPoint => {
      const date = new Date(dataPoint.date);
      total_units_delivered.push({y: dataPoint.total, myData: dataPoint});
      units_invoiced.push({y: dataPoint.invoiced, myData: dataPoint});
      units_delivered.push({y: dataPoint.delivered, myData: dataPoint});
      categories.push(`${date.getDate()} ${month[date.getMonth()]}`);
      total.push({y: dataPoint.total, myData: dataPoint});
      return dataPoint;
    });

    //HSET.tooltipFormatter(dataSets);
    return {
      success: true,
      dataSets,
      total_units_delivered,
      units_invoiced,
      units_delivered,
      categories,
      total
    };
  }

  createChart(chartData, Options) {
    const chart = HSET.chartData;
    chart.xAxis[0].categories = chartData.categories;
    chart.series[0].data = chartData.total_units_delivered;
    chart.series[1].data = chartData.units_invoiced;
    chart.series[2].data = chartData.units_delivered;
    return chart;
  }

  tooltipFormatter() {

  }
}
